import { invenioConfig } from "@config";
import _merge from "lodash/merge";

export const schema = () => {
  const _schema = {
    properties: {
      barcode: {
        type: "string",
        title: "Accession number",
      },
      circulation_restriction: {
        enum: invenioConfig.ITEMS.circulationRestrictions.map(
          (status) => status.value
        ),
        enumNames: invenioConfig.ITEMS.circulationRestrictions.map(
          (status) => status.text
        ),
        type: "string",
        title: "Circulation restriction",
      },
      description: {
        type: "string",
        title: "Description",
      },
      document_pid: {
        type: "string",
        title: "Document",
      },
      internal_location_pid: {
        type: "string",
        title: "Location",
      },
      internal_notes: {
        type: "string",
        title: "Internal Notes",
      },
      isbns: {
        items: {
          properties: {
            description: {
              title: "Refers to",
              type: "string",
            },
            value: {
              title: "Value",
              type: "string",
            },
          },
          required: ["value"],
          title: "ISBN",
          type: "object",
        },
        title: "ISBNs",
        type: "array",
      },
      medium: {
        enum: invenioConfig.ITEMS.mediums
          .sort((a, b) => a.order - b.order)
          .map((status) => status.value),
        enumNames: invenioConfig.ITEMS.mediums
          .sort((a, b) => a.order - b.order)
          .map((status) => status.text),
        type: "string",
        title: "Medium",
      },
      number_of_pages: {
        title: "Number of Pages",
        type: "integer",
      },
      shelf: {
        type: "string",
        title: "Shelf",
        // pattern: '^SH[0-9]{2}-[0-9]{4}$',
        // minLength: 1,
        // description: 'Shelf format (e.g., SH01-0000)',
        // errorMessage: {
        //   pattern:
        //     'Shelf must follow format SH01-0000 (SH + 2 digits + hyphen + 4 digits)',
        //   minLength: 'Shelf is required and cannot be empty',
        // },
      },
      rack: {
        type: "string",
        title: "Rack",
        // pattern: '^RK[0-9]{2}-[0-9]{4}$',
        // minLength: 0,
        // description: 'Rack format (e.g., RK01-0000)',
        // errorMessage: {
        //   pattern:
        //     'Rack must follow format RK01-0000 (RK + 2 digits + hyphen + 4 digits)',
        //   minLength: 'Rack is required and cannot be empty',
        // },
      },
      call_number_suffix: {
        type: "string",
        title: "Call Number Suffix",
        maxLength: 20,
      },
      identifiers: {
        items: {
          properties: {
            scheme: {
              title: "Scheme name",
              type: "string",
            },
            value: {
              title: "Value",
              type: "string",
            },
          },
          required: ["scheme", "value"],
          title: "Identifier",
          type: "object",
        },
        title: "Identifiers",
        type: "array",
      },
      status: {
        enum: invenioConfig.ITEMS.statuses.map((status) => status.value),
        enumNames: invenioConfig.ITEMS.statuses.map((status) => status.text),
        type: "string",
        title: "Status",
      },
    },
    required: [
      "internal_location_pid",
      "barcode",
      "status",
      "document_pid",
      "circulation_restriction",
      "medium",
      // 'shelf',
      // 'rack',
    ],
    type: "object",
  };
  return _merge(_schema, invenioConfig.ITEMS.editorSchema);
};
